export default "__VITE_ASSET__4c0fdc78__"